import { Submarine } from "components/Common/Icons/Submarine";
import { TelescopeB } from "components/Common/Icons/TelescopeB";
import { TelescopeS } from "components/Common/Icons/TelescopeS";
import { BulletList } from "components/Common/List/BulletList";
import { values } from "lodash";
import {
  CloudLightning,
  Hand,
  PawPrint,
  Plane,
  Scissors,
  Fence,
} from "lucide-react";

export const EXPANSIONS = {
  BASE_REACHES: "BASE_REACHES",
  SAR: "SAR",
  SAR_AIR: "SAR_AIR",
  SAR_SUB: "SAR_SUB",
  SAR_REACHES: "SAR_REACHES",
  SAR_NON_STANDARD: "SAR_NON_STANDARD",
  ONE_ARMED_SCISSOR: "ONE_ARMED_SCISSOR",
  RED_RIGHT_HAND: "RED_RIGHT_HAND",
  SHIP_GARDENS: "SHIP_GARDENS",
};

export const EXPANSIONS_VALUES = values(EXPANSIONS);

const SAR_EXPANSION_MODAL_CONFIG = {
  shouldCheckPurchase: true,
  skipPurchaseCheckKey: "shouldHideSarModal",
  expansionModalTitle: "Storm and Root",
  expansionModalBackgroundSrc: `${process.env.PUBLIC_URL}/StormAndRoot.png`,
};

export const EXPANSIONS_CONFIG = {
  [EXPANSIONS.BASE_REACHES]: {
    label: "Reaches (Base game)",
    logo: TelescopeB,
    shouldShowGroupExpansionEntry: true,
    groupExpansionTooltipContent: (
      <>
        <div>When enabled adds the following:</div>
        <br />
        <u>Bloodlines</u>
        <BulletList items={["Corron", "DaWheh-Whe"]} />
        <br />
        <u>Bites</u>
        <BulletList items={["Chainwheels"]} />
        <br />
        <u>Engines</u>
        <BulletList items={["Steam Exchange"]} />
      </>
    ),
  },
  [EXPANSIONS.SAR]: {
    label: "Storm and Root",
    logo: CloudLightning,
    shouldShowGroupExpansionEntry: true,
    groupExpansionLabel: (
      <>
        <CloudLightning style={{ marginBottom: "1px" }} />
        <span>Storm and Root,</span>
        <Plane style={{ marginBottom: "1px" }} />
        <span>Airships, and</span>
        <Submarine style={{ marginBottom: "1px" }} />
        <span>Submersibles</span>
      </>
    ),
    groupExpansionTooltipContent: (
      <>
        <div>When enabled adds the following:</div>
        <br />
        <u>Character Options</u>
        <BulletList
          items={[
            "1 bloodline",
            "5 origins",
            "12 posts",
            "Extra feats for all existing backgrounds",
          ]}
        />
        <br />
        <u>Ship Options</u>
        <BulletList
          items={[
            "New designs and ratings for submersibles and airships",
            "Extra options for existing Designs, Fittings, and Undercrew",
          ]}
        />
        <br />
        <u>Mechanics</u>
        <BulletList
          items={[
            "Scrutiny (found on the Ships page)",
            "Pressure Gauge (found on the GMs page)",
          ]}
        />
      </>
    ),
    ...SAR_EXPANSION_MODAL_CONFIG,
  },
  [EXPANSIONS.SAR_AIR]: {
    label: "Storm and Root - Airship",
    logo: Plane,
  },
  [EXPANSIONS.SAR_SUB]: {
    label: "Storm and Root - Submarine",
    logo: Submarine,
  },
  [EXPANSIONS.SAR_REACHES]: {
    label: "Reaches (Storm and Root)",
    logo: TelescopeS,
    shouldShowGroupExpansionEntry: true,
    groupExpansionTooltipContent: (
      <>
        <div>When enabled adds the following:</div>
        <br />
        <u>Bloodlines</u>
        <BulletList items={["Carcharbora"]} />
        <br />
        <u>Posts</u>
        <BulletList items={["Petrou"]} />
      </>
    ),
    ...SAR_EXPANSION_MODAL_CONFIG,
  },
  [EXPANSIONS.SAR_NON_STANDARD]: {
    label: "Non-Standard Bloodlines (Storm and Root)",
    logo: PawPrint,
    shouldShowGroupExpansionEntry: true,
    groupExpansionTooltipContent: (
      <>
        <div>When enabled adds aspects to the following Bloodlines:</div>
        <br />
        <BulletList
          items={[
            "Ardent",
            "Ektus",
            "Gau",
            "Ironbound",
            "Ketra",
            "Mothryn",
            "Tzelicrae",
            "Itzenko",
          ]}
        />
      </>
    ),
    ...SAR_EXPANSION_MODAL_CONFIG,
  },
  [EXPANSIONS.ONE_ARMED_SCISSOR]: {
    label: "One-Armed Scissor",
    logo: Scissors,
    shouldShowGroupExpansionEntry: true,
    groupExpansionTooltipContent: (
      <>
        <div>When enabled adds the following:</div>
        <br />
        <u>Posts</u>
        <BulletList items={["Spielographer"]} />
      </>
    ),
    shouldCheckPurchase: true,
    skipPurchaseCheckKey: "shouldHideOASModal",
    expansionModalBackgroundSrc: `${process.env.PUBLIC_URL}/one-armed-scissor.png`,
  },
  [EXPANSIONS.RED_RIGHT_HAND]: {
    label: "Red Right Hand",
    logo: Hand,
    shouldShowGroupExpansionEntry: true,
    groupExpansionTooltipContent: (
      <>
        <div>When enabled adds the following:</div>
        <br />
        <u>Posts</u>
        <BulletList items={["Augmentor"]} />
      </>
    ),
    shouldCheckPurchase: true,
    skipPurchaseCheckKey: "shouldHideRRHModal",
    expansionModalBackgroundSrc: `${process.env.PUBLIC_URL}/RedRightHand.png`,
  },
  [EXPANSIONS.SHIP_GARDENS]: {
    label: "Ship Gardens",
    logo: Fence,
    shouldShowGroupExpansionEntry: true,
    groupExpansionTooltipContent: (
      <>
        <div>When enabled adds the following:</div>
        <br />
        <u>Ship Options</u>
        <BulletList items={["Designs, Fittings, Undercrew"]} />
        <br />
        <u>Ship Sections</u>
        <BulletList items={["Plots"]} />
        <br />
        <u>Posts</u>
        <BulletList items={["Agronaut"]} />
      </>
    ),
    shouldCheckPurchase: true,
    skipPurchaseCheckKey: "shouldHideSGModal",
    expansionModalBackgroundSrc: `${process.env.PUBLIC_URL}/ShipGarden.jpg`,
  },
};
